import { BsArrowUpRight } from "react-icons/bs";
import "./Hiring.css";
import { Link } from "react-router-dom";
import useSendEvent from "hooks/useSendEvent";

const Hiring = () => {
  const { sendEvent } = useSendEvent();

  const handleSendEvent = (value) => {
    sendEvent(value, "home");
  };

  return (
    <section className="pb-[30px]">
      <section className="max-w-7xl mx-auto">
        <h2 className="text-[30px] md:text-[40px] lg:text-[60px] xl:text-[60px] 2xl:text-[60px] pb-[40px] text-center text-white">
          Hassle Free Hiring
        </h2>
        <div className="flex items-center justify-center gap-4 mb-2">
          <Link to="/career" onClick={() => handleSendEvent("Find a Job")}>
            <button className="flex items-center rounded-lg p-2 gap-2 bg-gray-200 text-[#FC1C69] font-semibold transition-all duration-300 ease-in-out hover:bg-[#FC1C69] hover:text-white">
              Find a Job <BsArrowUpRight />
            </button>
          </Link>
          <Link
            to="/hiringpage"
            onClick={() => handleSendEvent("Find a Talent")}
          >
            <button className="flex items-center find-a-job text-white rounded-lg p-2 gap-2 font-semibold transition-all duration-300 ease-in-out hover:bg-[#FC1C69] hover:text-white">
              Find a Talent <BsArrowUpRight />
            </button>
          </Link>
        </div>
        <main className="flex flex-col md:flex-row lg:flex-row xl:flex-row 2xl:flex-row items-center gap-3 mx-5 md:mx-10 lg:mx-20 xl:mx-20 2xl:mx-20">
          <div className="relative w-full">
            <img
              src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+64.webp"
              alt="talents"
              className="w-full"
            />
            <span className="absolute bottom-3 right-0 left-0 text-white text-center">
              Cyber Security Consultant
            </span>
          </div>
          <div className="w-full">
            <div className="mb-6 relative ">
              <img
                src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+65.webp"
                alt="talents"
                className="w-full"
              />
              <span className="absolute bottom-3 right-0 left-0 text-white text-center">
                Video Editor
              </span>
            </div>
            <img
              src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+68.webp"
              alt="talents"
              className=" w-full hidden md:block lg:block xl:block 2xl:block"
            />
          </div>
          <div className="mt-[85px] md:mt-[285px] lg:mt-[285px] xl:mt-[285px] 2xl:mt-[285px] w-full">
            <img
              src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+72.webp"
              alt="talents"
              className="mb-6 w-full hidden md:block lg:block xl:block 2xl:block"
            />
            <div className="relative w-full">
              <img
                src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+66.webp"
                alt="talents"
                className="w-full"
              />
              <span className="absolute bottom-3 right-0 left-0 text-white text-center">
                Full-Stack Developer
              </span>
            </div>
          </div>
          <div className="w-full">
            <div className="mb-6 relative">
              <img
                src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+70.webp"
                alt="talents"
                className="w-full"
              />
              <span className="absolute bottom-3 right-0 left-0 text-white text-center">
                Front-End Developer
              </span>
            </div>
            <img
              src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+68.webp"
              alt="talents"
              className="w-full hidden md:block lg:block xl:block 2xl:block"
            />
          </div>
          <div className="relative w-full">
            <img
              src="https://interactivecaresbucket.s3.ap-southeast-1.amazonaws.com/main-frontend/assets/Home/Hiring/Rectangle+71.webp"
              alt="talents"
              className="w-full"
            />
            <span className="absolute bottom-3 right-0 left-0 text-white text-center">
              Back-End Developer
            </span>
          </div>
        </main>
      </section>
    </section>
  );
};

export default Hiring;
